import {Crop, UserId, blobToBase64} from '@legit.health/ui';
import * as Sentry from '@sentry/react';
import {processAnamnesisQuestions} from '@/shared/components/diagnosticReport/DiagnosticReportForm/utils/mapFormValuesToApiFormat';

export default async function mapFormToDiagnosisSupportBody(values: {
  images: {
    id: string;
    crop: Crop | null;
    file: Blob | null;
  }[];
  bodySite: string | number;
  patientId: UserId;
  visitIdentifier: string | null;
  anamnesisQuestions: Record<string, string>;
}) {
  values.images.forEach(function (image) {
    if (image.file && !image.crop) {
      Sentry.captureException(new Error('Image with file but not crop'));
    }
  });
  const images = await Promise.all(
    values.images
      .filter((i) => i.file && i.crop)
      .map(async function (image) {
        if (!image.crop || !image.file) {
          return null;
        }
        let base64Image = null;
        try {
          base64Image = await blobToBase64(image.file);
        } catch (error) {
          Sentry.captureException(error, {
            extra: {
              haveCrop: image.crop === null ? 'no' : 'yes',
              haveImage: image.file === null ? 'no' : 'yes',
              type: typeof image.file,
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              mimeType: image.file instanceof Blob ? image.file.type : 'unknown',
              value:
                typeof image.file === 'string'
                  ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    values.image.file.substring(0, 50)
                  : 'maybe a file',
              data: 'blobToBase64 error',
              values: JSON.stringify({
                cropDimensions: image.crop ?? '',
                hasImage: image.file ? 'yes' : 'no'
              })
            }
          });
          throw error;
        }
        return {
          x: image.crop.x,
          y: image.crop.y,
          width: image.crop.width,
          height: image.crop.height,
          image: base64Image
        };
      })
      .filter((i) => Boolean(i))
  );
  return {
    images,
    patient: values.patientId,
    bodySite: values.bodySite,
    visitIdentifier: values.visitIdentifier,
    anamnesisQuestions: processAnamnesisQuestions(values.anamnesisQuestions)
  };
}
